import React from 'react';
import {
  InvoiceTaskComment,
  PaymentTaskComment,
  PurchaseOrderComment,
  PurchaseOrderContractTaskComment,
  QuotationTaskComment,
  SalesOrderComment,
  SalesOrderContractTaskComment,
} from '@/hooks/api/models';

type Props = {
  comment:
    | PurchaseOrderComment
    | PurchaseOrderContractTaskComment
    | SalesOrderComment
    | SalesOrderContractTaskComment
    | QuotationTaskComment
    | InvoiceTaskComment
    | PaymentTaskComment;
};

export const CommentContent = (props: Props) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: props.comment.content,
      }}
    />
  );
};
